import ReactSelect from "components/Form/Select/Select";
import React, { useEffect, useState } from "react";
import { Button, ButtonGroup, Card, CardBody, CardHeader, CardTitle, Col, Collapse, Container, DropdownItem, DropdownMenu, DropdownToggle, FormGroup, Input, Label, Modal, Row, UncontrolledDropdown } from "reactstrap";
import TablePedidos from './DataTable/TablePedidos';
import './index.css';
import TagsInput from "react-tagsinput";
import GerarRemessa from "./GerarRemessa/GerarRemessa";
import CotacaoDigifarma from "./CotacaoDigifarma/CotacaoDigifarma";
import Swal from "sweetalert2";
import IncluirProduto from "./IncluirProduto/IncluirProduto";
import ConfigurarPedidos from "./Configuracao/ConfigurarPedidos";
import rotas from "services/rotas";
import rest from "lib/rest";
import { toast, ToastContainer } from "react-toastify";
import Analisar from "./Analisar/Analisar";
import Sessoes from "./Sessoes/Sessoes";
import Movimentação from "./DataTable/Movimentacao";
import { homepage } from '../../../../package.json';
import SmartPed from "./SmartPed/SmartPed";
import Iframe from "react-iframe";

const AssistentePedidos = () => {


  //const [colunas, setColunas] = useState(initialColunas);

  const initialFiltro = {
    categoria_id: {
      description: 'Categoria',
      name: 'categoria_id',
      value: null
    },

    subcategoria_id: {
      description: 'Subcategoria',
      name: 'subcategoria_id',
      value: null
    },

    curva_classe: {
      description: 'Curva ABC',
      name: 'curva_classe',
      value: null
    },

    fabricante_id: {
      description: 'Fabricante',
      name: 'fabricante_id',
      value: null
    },

    grupo_id: {
      description: 'Grupo de Compras',
      name: 'grupo_id',
      value: null
    },

    substancia_id: {
      description: 'Substância',
      name: 'substancia_id',
      value: null
    },

    last_fornecedor_id: {
      description: 'Fornecedor',
      name: 'last_fornecedor_id',
      value: null
    },

    todos_produtos: {
      description: 'Todos os Produtos',
      name: 'todos_produtos',
      value: false
    },

    saldo_zero: {
      description: 'Saldo 0',
      name: 'saldo_zero',
      value: false
    },

    porLaboratorio: {
      name: 'Por Laboratório',
      value: false
    },

    porQuantVendida: {
      name: 'Por Quantidade Vendida',
      value: false
    }
  }

  const initialPeriodo = {
    dataI: '',
    dataF: ''
  }

  const [data, setData] = useState([]);
  const [filtro, setFiltro] = useState(initialFiltro);
  const [isOpenFiltros, setIsOpenFiltros] = useState(false);
  const [isOpenModalRemessa, setIsOpenModalRemessa] = useState(false);
  const [isOpenModalCotacao, setIsOpenModalCotacao] = useState(false);
  const [isOpenModalIncluirProd, setIsOpenModalIncluirProd] = useState(false);
  const [isOpenModalConfig, setIsOpenModalConfig] = useState(false);
  const [isOpenDetalhesLojas, setIsOpenDetaslheLojas] = useState(false);
  const [isOpenModalAnalisar, setIsOpenModalAnalisar] = useState(false);
  const [isOpenModalSessao, setIsOpenModalSessao] = useState(true);
  const [isOpenModalSmartPed, setIsOpenModalSmartPed] = useState(false);
  const [isOpenModalImpressao, setIsOpenModalImpressao] = useState(false);
  const [pathPDF, setPathPDF] = useState('');
  const [listaCategoria, setListaCategoria] = useState([]);
  const [listaSubcategoria, setListaSubcategoria] = useState([]);
  const [listaAbc, setListaAbc] = useState([{ id: 'A', title: 'A' }, { id: 'B', title: 'B' }, { id: 'C', title: 'C' }]);
  const [listaFabricante, setListaFabricante] = useState([]);
  const [listaGrupoCompra, setListaGrupoCompra] = useState([]);
  const [listaLojas, setListaLojas] = useState([]);
  const [listaSubstancia, setListaSubstancia] = useState([]);
  const [listaFornecedores, setListaFornecedores] = useState([]);
  const [tags, setTags] = useState([]);
  const [filial_id, setFilial_id] = useState('');
  const [loadingRow, setLoadingRow] = useState(false);
  const [sessao_id, setSessao_id] = useState('');
  const [exibirMovimentacao, setExibirMovimentacao] = useState(false);
  const [listaMovimetacao, setListaMovimentacao] = useState([]);
  const [listaUltimosAnos, setistaListaUltimosAnos] = useState([]);
  const [periodoAnalise, setPeriodoAnanlise] = useState(initialPeriodo);
  // const [collapseMovimentacao, setCollapseMovimentacao] = useState(false);

  useEffect(() => {
    listarCategorias();
    listarSubcategorias();
    listarFabricantes();
    listarGrupoCompras();
    listarSubstacias();
    listarForneceodres();
    listarLojas();
  }, []);

  useEffect(() => {
    let tg = [];
    Object.keys(filtro).map(key => {
      if ((filtro[key].value != null) && (filtro[key].value != false)) {
        tg.push(filtro[key].description);
      }
    });
    setTags(tg);
  }, [filtro]);

  useEffect(() => {
    if (filial_id != '') {
      listarProdutos();
    }
  }, [filial_id]);

  useEffect(() => {
    if (isOpenFiltros == false) {
      listarProdutos();
    }
  }, [isOpenFiltros])

  useEffect(() => {
    if (isOpenModalAnalisar == false) {
      listarProdutos();
    }
  }, [isOpenModalAnalisar])

  useEffect(() => {
    if (isOpenModalIncluirProd == false) {
      listarProdutos();
    }
  }, [isOpenModalIncluirProd])

  useEffect(() => {
    if ((isOpenModalSessao == false) && (sessao_id != '')) {
      listarProdutos();
    }
  }, [sessao_id])

  const colunas = [
    // {
    //   datafield: '',
    //   text: '',
    //   headerStyle: { cursor: 'default' },
    //   width: '50px',
    //   checkbox: false,
    //   visible:true, 
    //   readOnly:true
    // },
    {
      datafield: 'produto_id',
      text: 'Código',
      headerStyle: { cursor: 'default' },
      width: '60px',
      checkbox: false,
      visible: true,
      readOnly: true
    },
    // {
    //   datafield: 'produto',
    //   text: 'Produto',
    //   headerStyle: { cursor: 'default' },
    //   width: '200px',
    //   checkbox: false,
    //   visible:true, 
    //   readOnly:true
    // },
    // {
    //   datafield: 'apresentacao',
    //   text: 'Apresentação',
    //   headerStyle: { cursor: 'default' },
    //   width: '200px',
    //   checkbox: false,
    //   visible:true, 
    //   readOnly:true
    // },
    {
      datafield: 'pedido_saldo',
      text: 'Saldo',
      headerStyle: { cursor: 'default' },
      width: '50px',
      checkbox: false,
      visible: true,
      readOnly: true
    }, {
      datafield: 'prod_estminimo',
      text: 'Est. Min.',
      headerStyle: { cursor: 'default' },
      width: '60px',
      checkbox: false,
      visible: true,
      readOnly: true
    }, {
      datafield: 'pedido_equivalentes',
      text: 'Saldo Equiv.',
      headerStyle: { cursor: 'default' },
      width: '50px',
      checkbox: false,
      visible: true,
      readOnly: true
    }, {
      datafield: 'pedido_totalvenda',
      text: 'Total Venda',
      headerStyle: { cursor: 'default' },
      width: '50px',
      checkbox: false,
      visible: true,
      readOnly: true
    }, {
      datafield: 'pedido_mediavenda',
      text: 'Média',
      headerStyle: { cursor: 'default' },
      width: '50px',
      checkbox: false,
      visible: true,
      readOnly: true
    }, {
      datafield: 'ciclo',
      text: 'Ciclo',
      headerStyle: { cursor: 'default' },
      width: '50px',
      checkbox: false,
      visible: true,
      readOnly: true
    },
    // {
    //   datafield: 'prod_lista',
    //   text: 'ABC',
    //   headerStyle: { cursor: 'default' },
    //   width: '50px',
    //   checkbox: false,
    //   visible: true,
    //   readOnly: true
    // },
    {
      datafield: 'lucro',
      text: 'Lucro Obtido',
      headerStyle: { cursor: 'default' },
      width: '50px',
      checkbox: false,
      visible: true,
      readOnly: true
    }, {
      datafield: 'pedido_qtpedido',
      align: 'center',
      text: 'Pedir',
      headerStyle: { cursor: 'default' },
      width: '50px',
      checkbox: false,
      visible: true,
      readOnly: false,
      editable: filial_id == 0 ? false : true
    }, {
      datafield: 'valor_ult_compra',
      text: 'Última Compra',
      headerStyle: { cursor: 'default' },
      width: '60px',
      checkbox: false,
      visible: true,
      readOnly: true
    }, {
      datafield: 'last_prliquido',
      text: 'Últ. Pr. Líq.',
      headerStyle: { cursor: 'default' },
      width: '60px',
      checkbox: false,
      visible: true,
      readOnly: true
    }, {
      datafield: 'pedido_vencimento_proximo',
      text: 'Venc. Próximo',
      headerStyle: { cursor: 'default' },
      width: '60px',
      checkbox: false,
      visible: true,
      readOnly: true
    }, {
      datafield: 'fabricante',
      text: 'Fabricante',
      headerStyle: { cursor: 'default' },
      width: '200px',
      checkbox: false,
      visible: true,
      readOnly: true
    }, {
      datafield: 'categoria',
      text: 'Categoria',
      headerStyle: { cursor: 'default' },
      width: '150px',
      checkbox: false,
      visible: true,
      readOnly: true
    }, {
      datafield: 'cod_barras',
      text: 'Cód Barras',
      headerStyle: { cursor: 'default' },
      width: '100px',
      checkbox: false,
      visible: true,
      readOnly: true
    }, {
      datafield: 'cod_barras_hospitalar',
      text: 'Cód Barras Hospitalar',
      headerStyle: { cursor: 'default' },
      width: '100px',
      checkbox: false,
      visible: true,
      readOnly: true
    }, {
      datafield: 'ultimo_fornecedor',
      text: 'Último Fornecedor',
      headerStyle: { cursor: 'default' },
      width: '200px',
      checkbox: false,
      visible: true,
      readOnly: true
    }]

  /*const data = [
    {
      produto_id: 12537,
      produto: "- DIPIRONA 500MG 50X10 CPS / GEN DIPIRONA SODICA",
      apresentacao: '50X10 CPS / GEN DIPIRONA SODICA',
      vencimento_proximo: 0,
      fabricante: "NDS DISTRIBUIDORA DE MEDICAMENTOS LTDA",
      categoria: "VAREJO",
      cod_barras: '123456789',
      cod_barras_hospitalar: '987654321',
      ultimo_fornecedor: "NDS DISTRIBUIDORA DE MEDICAMENTOS LTDA",
      prod_saldo: 6,
      prod_estminimo: 0,
      totalvenda: 95.32,
      pedido_mediavenda: 0.32,
      prod_equivalente: 0,
      ciclo: 3.2,
      prod_lista: 'A',
      lucro_obtido: 5.97,
      pedido_qtpedido: 3,
      valor_ult_compra: 2.50,
      prod_prliquido: 2.35,
      collapsed: false,
      lojas: [{
        filial_id: 1,
        fantasia: 'FARMACIA 1',
        prod_saldo: 3,
        prod_estminimo: 0,
        total_venda: 23.95,
        pedido_mediavenda: 0.36,
        ciclo: 3.2,
        prod_lista: 'A',
        lucro_obtido: 5.97,
        pedido_qtpedido: 3,
        valor_ult_compra: 2.50,
        prod_prliquido: 2.35,
      }, {
        filial_id: 2,
        fantasia: 'FARMACIA 2',
        prod_saldo: 3,
        prod_estminimo: 0,
        total_venda: 32.97,
        pedido_mediavenda: 0.48,
        ciclo: 2.5,
        prod_lista: 'A',
        lucro_obtido: 10.50,
        pedido_qtpedido: 3,
        valor_ult_compra: 2.65,
        prod_prliquido: 2.41,
      }, {
        filial_id: 3,
        fantasia: 'FARMACIA 3',
        prod_saldo: 0,
        prod_estminimo: 0,
        total_venda: 18.38,
        pedido_mediavenda: 0.04,
        ciclo: 4.3,
        prod_lista: 'A',
        lucro_obtido: 2.87,
        pedido_qtpedido: 5,
        valor_ult_compra: 2.56,
        prod_prliquido: 2.49,
      }]
    }, {
      produto_id: 12538,
      produto: "- DIPIRONA 1000MG 10 CPS / GEN DIPIRONA SODICA",
      apresentacao: '10 CPS / GEN DIPIRONA SODICA',
      vencimento_proximo: 0,
      fabricante: "NDS DISTRIBUIDORA DE MEDICAMENTOS LTDA",
      categoria: "VAREJO",
      cod_barras: '123456789',
      cod_barras_hospitalar: '987654321',
      ultimo_fornecedor: "NDS DISTRIBUIDORA DE MEDICAMENTOS LTDA",
      prod_saldo: 6,
      prod_estminimo: 0,
      totalvenda: 95.32,
      pedido_mediavenda: 0.32,
      prod_equivalente: 0,
      ciclo: 3.2,
      prod_lista: 'A',
      lucro_obtido: 5.97,
      pedido_qtpedido: 3,
      valor_ult_compra: 2.50,
      prod_prliquido: 2.35,
      collapsed: false,
      lojas: [{
        filial_id: 1,
        fantasia: 'FARMACIA 1',
        prod_saldo: 3,
        prod_estminimo: 0,
        total_venda: 23.95,
        pedido_mediavenda: 0.36,
        ciclo: 3.2,
        prod_lista: 'A',
        lucro_obtido: 5.97,
        pedido_qtpedido: 3,
        valor_ult_compra: 2.50,
        prod_prliquido: 2.35,
      }, {
        filial_id: 2,
        fantasia: 'FARMACIA 2',
        prod_saldo: 3,
        prod_estminimo: 0,
        total_venda: 32.97,
        pedido_mediavenda: 0.48,
        ciclo: 2.5,
        prod_lista: 'A',
        lucro_obtido: 10.50,
        pedido_qtpedido: 3,
        valor_ult_compra: 2.65,
      }, {
        filial_id: 3,
        fantasia: 'FARMACIA 3',
        prod_saldo: 0,
        prod_estminimo: 0,
        total_venda: 18.38,
        pedido_mediavenda: 0.04,
        ciclo: 4.3,
        prod_lista: 'A',
        lucro_obtido: 2.87,
        pedido_qtpedido: 5,
        valor_ult_compra: 2.56
      }
      ]
    }
  ]*/


  const modalRemessa = () => {
    setIsOpenModalRemessa(!isOpenModalRemessa);
  }

  const modalCotacao = () => {
    setIsOpenModalCotacao(!isOpenModalCotacao);
  }

  const modalIncluirProd = () => {
    if ((filial_id != '0') && (filial_id != '')) {
      setIsOpenModalIncluirProd(!isOpenModalIncluirProd);
    } else {
      Swal.fire('Atenção', 'Selecione uma loja!', 'warning');
    }
  }

  const modalConfig = () => {
    setIsOpenModalConfig(!isOpenModalConfig);
  }

  const modalAnalisar = () => {
    setIsOpenModalAnalisar(!isOpenModalAnalisar);
  }

  const modalSessao = () => {
    setIsOpenModalSessao(!isOpenModalSessao);
  }

  const modalSmartPed = () => {
    setIsOpenModalSmartPed(!isOpenModalSmartPed);
  }

  const listarProdutos = () => {
    const url = rotas.pedidos;
    let listaFiltros = '';

    if (filial_id == '') {
      return;
    }

    if (sessao_id == '') {
      return;
    }

    Object.keys(filtro).map(key => {
      //filtra pelos componentes lisbox
      if ((filtro[key].value != null) && (Array.isArray(filtro[key].value))) {
        listaFiltros += `&${filtro[key].name}=`;
        filtro[key].value.map(item => {
          if (Number.isInteger(item.id)) {
            listaFiltros += `${item.id},`;
          } else {
            listaFiltros += `'${item.id}',`;
          }
        })
        listaFiltros = listaFiltros.slice(0, -1);
      } else {
        //filtra pelos componentes checkbox
        if (filtro[key].value != null) {
          if (filtro[key].value != false) {
            listaFiltros += `&${filtro[key].name}=${filtro[key].value}`;
          }
        }
      }


    })



    /* if(listaAbc.length > 0){
       listaAbc.map(lista=>{
         abc += lista.id + ',';
       })
       abc.slice(0,-1);
       abc = '&curva_classe=' + abc;
     }
 
     if(listaCategoria.length > 0){
       listaCategoria.map(lista=>{
         categoria += lista.id + ',';
       })
       categoria.slice(0,-1);
       categoria = '&categoria_id=' + categoria;
     }
 
     if(listaFabricante.length > 0){
       listaFabricante.map(lista=>{
         fabricante += lista.id + ',';
       })
       fabricante.slice(0,-1);
       fabricante = '&fabricante_id=' + fabricante;
     }
     
     if(listaFornecedores.length > 0){
       listaFornecedores.map(lista=>{
         fornecedores += lista.id + ',';
       })
       fornecedores.slice(0,-1);
       fornecedores = '&last_fornecedor_id=' + fornecedores;
     }
     
     if(listaGrupoCompra.length > 0){
       listaGrupoCompra.map(lista=>{
         grupo += lista.id + ',';
       })
       grupo.slice(0,-1);
       grupo = '&grupo_id=' + grupo;
     }
 
     if(listaSubcategoria.length > 0){
       listaSubcategoria.map(lista=>{
         subcategoria += lista.id + ',';
       })
       subcategoria.slice(0,-1);
       subcategoria = '&subcategoria_id=' + subcategoria;
     }
 
     if(listaSubstancia.length > 0){
       listaSubstancia.map(lista=>{
         substancia += lista.id + ',';
       })
       substancia.slice(0,-1);
       substancia = '&substancia_id=' + substancia;
     }*/

    const retorno = rest.get(url + '?filial_id=' + filial_id + listaFiltros + '&sessao_id=' + sessao_id);

    retorno.then(ret => {
      let totalVenda = 0;
      let mediaVenda = 0;
      let ciclo = 0;
      let qtPedir = 0;
      let qtdeLojas = 0;
      let prodEstminimo = 0;
      let pedidoSaldo = 0;

      if (ret.success == 'S') {
        //se for todas as lojas, soma as quantidades
        ret.lista.map(produto => {
          qtdeLojas = produto.lojas.length;

          totalVenda = 0;
          mediaVenda = 0;
          ciclo = 0;
          qtPedir = 0;
          qtdeLojas = 0;

          produto.lojas.map(item => {
            totalVenda += parseFloat(item.pedido_totalvenda);
            mediaVenda += parseFloat(item.pedido_mediavenda);
            ciclo += parseFloat(item.ciclo);
            qtPedir += parseFloat(item.pedido_qtpedido);
            prodEstminimo += parseFloat(item.prod_estminimo);
            pedidoSaldo += parseFloat(item.pedido_saldo);
          })

          produto.pedido_totalvenda = totalVenda;
          produto.pedido_mediavenda = mediaVenda;
          produto.pedido_qtpedido = qtPedir;
          produto.ciclo = (ciclo > 0) ? (ciclo / qtdeLojas) : '0';
          produto.prod_estminimo = prodEstminimo;
          produto.pedido_saldo = pedidoSaldo;



        })

        setData(ret.lista);       
      } else {
        toast('Erro ao listar os produtos!');
      }
    })
  }

  const listarLojas = () => {
    const url = rotas.lojas;

    const retorno = rest.get(url);

    retorno.then(ret => {
      if (ret.success == 'S') {
        let ljs = [{ id: '0', title: "TODAS" }];

        ret.lista.map(loja => {
          ljs.push({
            id: loja.filial_id,
            title: loja.fantasia
          })
        })
        setListaLojas(ljs);
      }
    })
  }

  const listarCategorias = () => {
    const url = rotas.categoriaPedidos;

    const retorno = rest.get(url);

    retorno.then(ret => {
      if (ret.success == 'S') {
        let categ = [];

        ret.lista.map(categoria => {
          categ.push({
            id: categoria.categoria_id,
            title: categoria.categoria
          })
        })
        setListaCategoria(categ);
      }
    })
  }

  const listarSubcategorias = () => {
    const url = rotas.subcategoriaPedidos;

    const retorno = rest.get(url);

    retorno.then(ret => {
      if (ret.success == 'S') {
        let subcateg = [];

        ret.lista.map(subcategoria => {
          subcateg.push({
            id: subcategoria.subcategoria_id,
            title: subcategoria.subcategoria
          })
        })
        setListaSubcategoria(subcateg);
      }
    })
  }

  const listarFabricantes = () => {
    const url = rotas.fabricantePedidos;

    const retorno = rest.get(url);

    retorno.then(ret => {
      if (ret.success == 'S') {
        let fab = [];

        ret.lista.map(fabricante => {
          fab.push({
            id: fabricante.fabricante_id,
            title: fabricante.fornecedor
          })
        })
        setListaFabricante(fab);
      }
    })
  }

  const listarGrupoCompras = () => {
    const url = rotas.grupoComprasPedido;

    const retorno = rest.get(url);

    retorno.then(ret => {
      if (ret.success == 'S') {
        let grupo = [];

        ret.lista.map(grupoCompra => {
          grupo.push({
            id: grupoCompra.grupo_id,
            title: grupoCompra.grupo
          })
        })
        setListaGrupoCompra(grupo);
      }
    })
  }

  const listarSubstacias = () => {
    const url = rotas.substanciaPedidos;

    const retorno = rest.get(url);

    retorno.then(ret => {
      if (ret.success == 'S') {
        let subst = [];

        ret.lista.map(substancia => {
          subst.push({
            id: substancia.substancia_id,
            title: substancia.substancia
          })
        })
        setListaSubstancia(subst);
      }
    })
  }

  const listarForneceodres = () => {
    const url = rotas.fornecedoresPedidos;

    const retorno = rest.get(url);

    retorno.then(ret => {
      if (ret.success == 'S') {
        let forn = [];

        ret.lista.map(fornecedor => {
          forn.push({
            id: fornecedor.fornecedor_id,
            title: fornecedor.fornecedor
          })
        })
        setListaFornecedores(forn);
      }
    })
  }

  const onChangeLoja = (e) => {
    setFilial_id(e.id);
  }

  const onChangeFiltro = (e, name) => {
    const { value, checked } = e.target;
    let flt = { ...filtro };

    if (checked != undefined) {
      flt[name].value = checked;
    } else {
      flt[name].value = value;
    }

    setFiltro(flt);
    // setFiltro({ ...filtro, [name]: value });   
  }

  const onChangeSelect = (e, name) => {
    let param = {
      type: 'select',
      target: {
        name: name,
        value: e
      }
    }
    onChangeFiltro(param, name);
  }

  const onBlurQtde = (dadosProduto, numeroFilial) => {
    setLoadingRow(dadosProduto.pedido_id);

    let parametros = {};
    //edita com uma apenas uma loja selecionada
    if (filial_id != '0') {
      parametros = {
        pedido_id: dadosProduto.pedido_id,
        produto_id: dadosProduto.produto_id,
        novo_valor: dadosProduto.novo_valor,
        filial_id: filial_id
      }
    } else {
      //edita de uma loja com todas selecionadas
      parametros = {
        pedido_id: dadosProduto.pedido_id,
        produto_id: dadosProduto.produto_id,
        novo_valor: dadosProduto.novo_valor,
        filial_id: numeroFilial
      }
    }

    const url = rotas.pedidoAtualizaQuantidade;

    const retorno = rest.post(url, parametros);

    retorno.then(ret => {
      if (ret.success == 'S') {
        let dt = [...data];
        let totalPedir = 0;

        dt.map(produto => {
          if (produto.produto_id == dadosProduto.produto_id) {
            produto.lojas.map(item => {
              if (item.pedido_id == dadosProduto.pedido_id) {
                totalPedir += parseInt(dadosProduto.novo_valor);
                item.pedido_qtpedido = dadosProduto.novo_valor;
              } else {
                totalPedir += parseInt(item.pedido_qtpedido);
              }
            })
            produto.pedido_qtpedido = totalPedir;
          }
        })
        setData(dt);
      } else {
        toast('Erro na atualização da quantidade!');
      }
      setLoadingRow(false);
    })
  }

  const gerarCotefacil = () => {
    Swal.fire({
      title: "Confirmação",
      text: "Confirma geração de arquivo para o Cote Fácil?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim"
    }).then((result) => {
      if (result.isConfirmed) {
        const url = rotas.pedidoCoteFacil;

        const parametros = {
          produtos: data
        }

        const retorno = rest.post(url, parametros);

        retorno.then(ret => {
          if (ret.success == 'S') {
            // console.log(homepage + rotas.pedidoCoteFacil + ret.path);
                        downloadFile(homepage + rotas.pedidoCoteFacil + ret.path);
                        // downloadFile(homepage + rotas.pedidoCoteFacil + ret.path);
                  downloadFile(rotas.pedidoCoteFacil + ret.path);
                  // downloadFile(rotas.pedidoCoteFacil + ret.path);
          }
        })

      }
    });
  }

  const gerarSic = () => {
    Swal.fire({
      title: "Confirmação",
      text: "Confirma geração de arquivo para o SIC (Febrafar)?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim"
    }).then((result) => {
      if (result.isConfirmed) {
        const url = rotas.pedidoSic;

        const parametros = {
          produtos: data,
          filial_id:filial_id
        }

        const retorno = rest.post(url, parametros);

        retorno.then(ret => {
          if (ret.success == 'S') {
            // console.log(homepage + rotas.pedidoCoteFacil + ret.path);
                        downloadFile(homepage + rotas.pedidoCoteFacil + ret.path);
                        // downloadFile(homepage + rotas.pedidoCoteFacil + ret.path);
                  downloadFile(rotas.pedidoSic + ret.path);
                  // downloadFile(rotas.pedidoSic + ret.path);
          }
        })
      }
    });
  }

  const gerarCentralCotacoes = () => {
    Swal.fire({
      title: "Confirmação",
      text: "Confirma geração de arquivo para a Central de Cotações?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim"
    }).then((result) => {
      if (result.isConfirmed) {
        const url = rotas.pedidoCentralCotacoes;

        const parametros = {
          produtos: data,
          filial_id:filial_id
        }

        const retorno = rest.post(url, parametros);

        retorno.then(ret => {
          if (ret.success == 'S') {
            // console.log(homepage + rotas.pedidoCoteFacil + ret.path);
                        downloadFile(homepage + rotas.pedidoCoteFacil + ret.path);
                        // downloadFile(homepage + rotas.pedidoCoteFacil + ret.path);
                  downloadFile(rotas.pedidoCentralCotacoes + ret.path);
                  // downloadFile(rotas.pedidoCentralCotacoes + ret.path);
          }
        })

      }
    });
  }

  const gerarCoteSimples = () => {
    Swal.fire({
      title: "Confirmação",
      text: "Confirma geração de arquivo para Cote Simples?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim"
    }).then((result) => {
      if (result.isConfirmed) {
        const url = rotas.pedidoCoteSimples;

        const parametros = {
          produtos: data,
          filial_id:filial_id
        }

        const retorno = rest.post(url, parametros);

        retorno.then(ret => {
          if (ret.success == 'S') {
            // console.log(homepage + rotas.pedidoCoteFacil + ret.path);
                        downloadFile(homepage + rotas.pedidoCoteFacil + ret.path);
                        // downloadFile(homepage + rotas.pedidoCoteFacil + ret.path);
                  downloadFile(rotas.pedidoCoteSimples + ret.path);
                  // downloadFile(rotas.pedidoCoteSimples + ret.path);
          }
        })

      }
    });
  }

  const gerarSmartGruppy = () => {
    Swal.fire({
      title: "Confirmação",
      text: "Confirma geração de arquivo para Smart Gruppy?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim"
    }).then((result) => {
      if (result.isConfirmed) {
        const url = rotas.pedidoSmartGruppy;

        const parametros = {
          produtos: data,
          filial_id:filial_id
        }

        const retorno = rest.post(url, parametros);

        retorno.then(ret => {
          if (ret.success == 'S') {
            // console.log(homepage + rotas.pedidoCoteFacil + ret.path);
                        downloadFile(homepage + rotas.pedidoCoteFacil + ret.path);
                        // downloadFile(homepage + rotas.pedidoCoteFacil + ret.path);
                  downloadFile(rotas.pedidoSmartGruppy + ret.path);
                  // downloadFile(rotas.pedidoSmartGruppy + ret.path);
          }
        })

      }
    });
  }

  const importarFaltas = () => {
    Swal.fire({
      title: "Confirma importação do caderno de faltas?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "SIM",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        const url = rotas.pedidoFaltas;
        return rest.get(url + '?filial_id=' + filial_id + '&sessao_id=' + sessao_id);
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value.success == 'S') {
          listarProdutos();
        } else {
          Swal.fire('Atenção', 'Erro ao Importar o Caderno de Faltas!', 'warning');
        }
      } else {
        Swal.fire('Atenção', 'Erro ao Importar o Caderno de Faltas!', 'warning');
      }
    });
  }

  const apagarPedido = () => {
    let mensagem = '';

    if (filial_id == '0') {
      mensagem = 'Confirma a remoção do pedidos de TODAS AS LOJAS?';
    } else {
      mensagem = 'Confirma a remoção do pedido?';
    }

    Swal.fire({
      title: mensagem,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "SIM",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        const url = rotas.pedidos;
        return rest.del(url + '?filial_id=' + filial_id + '&sessao_id=' + sessao_id);
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value.success == 'S') {
          Swal.fire('Sucesso', 'Pedido Removido com Sucesso!', 'success');
          listarProdutos()
        } else {
          Swal.fire('Atenção', 'Erro ao Remover o Pedido!', 'warning');
        }
      }
    });
  }

  const listarMovimentacao = (produto_id) => {
    setListaMovimentacao([]);

    listarUltimosAnos(produto_id);

    const url = rotas.pedidoMovimentacao;

    const retorno = rest.get(url + '?produto_id=' + produto_id + '&filial_id=' + filial_id);

    retorno.then(ret => {
      if (ret.success == 'S') {
        setListaMovimentacao(ret.lista);
      } else {
        Swal.fire('Atenção', 'Erro na consulta de movimentação!', 'warning');
      }
    })
  }

  const listarUltimosAnos = (produto_id) => {

    setistaListaUltimosAnos([]);

    const url = rotas.pedidoMovimentacao;

    const parametros = {
      sessao_id: sessao_id,
      produto_id: produto_id
    }

    const retorno = rest.post(url, parametros);

    retorno.then(ret => {
      if (ret.success == 'S') {
        setistaListaUltimosAnos(ret.lista);
      } else {
        Swal.fire('Atenção', 'Erro na consulta de movimentação!', 'warning');
      }
    })
  }

  const openDetalhesLojas = () => {
    setIsOpenDetaslheLojas(!isOpenDetalhesLojas);
  }

  const showAnalisar = () => {
    if (filial_id == '') {
      Swal.fire('Atenção', 'Por favor selecione uma filial!', 'warning');
      return;
    } else {
      modalAnalisar();
    }
  }

  const downloadFile = async (fileUrl) => {
  // nst downloadFile = async (fileUrl) => {
    const nomeArq = fileUrl.split('/');

    const response = await fetch(fileUrl);
    const blob = await response.blob();
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = nomeArq[(nomeArq.length - 1)];
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(link.href);


    // const link = document.createElement('a');
    // const nomeArq = fileUrl.split('/');

    // console.log(nomeArq[(nomeArq.length - 1)]);
    // console.log(fileUrl);
    // return;

    // link.href = fileUrl;
    // link.download = nomeArq[(nomeArq.length - 1)]; 
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
  }

  const imprimirPedido = () =>{
    const url = rotas.pedidoImprimir;

    const parametros = {
      produtos:data,
      filial_id:filial_id
    } 

    const retorno = rest.post(url,parametros);

    retorno.then(ret=>{
      if(ret.success == 'S'){
        // setPathPDF(homepage + '/webgestor/api' + ret.path));        
        setPathPDF(homepage + '/webgestor/api/pedidos/assistente/impressao/pedido' + ret.path);
        
        setIsOpenModalImpressao(true);
        
      }
    })
  }

  const exportarExcel = () =>{
    const url = rotas.pedidoExcel;

    const parametros = {
      produtos:data
    }

    const retorno = rest.post(url,parametros);


    retorno.then(ret=>{
      if(ret.success == 'S'){
          downloadFile(rotas.pedidoExcel + ret.path);
          // downloadFile(homepage + '/webgestor/api/' + ret.path);
      }
    })
  }

  return (
    <div className="content">

      <Container>
        <ToastContainer></ToastContainer>
        <Modal size="lg" isOpen={isOpenModalRemessa}><GerarRemessa onClose={modalRemessa} produtos={data} filial_id={filial_id}></GerarRemessa></Modal>
        <Modal size="lg" isOpen={isOpenModalCotacao}><CotacaoDigifarma filial_id={filial_id} onClose={modalCotacao} produtos={data}></CotacaoDigifarma></Modal>
        <Modal size="lg" isOpen={isOpenModalIncluirProd}><IncluirProduto filial_id={filial_id} sessao_id={sessao_id} onClose={modalIncluirProd}></IncluirProduto></Modal>
        <Modal size="lg" isOpen={isOpenModalConfig}><ConfigurarPedidos onClose={modalConfig}></ConfigurarPedidos></Modal>
        <Modal size="lg" isOpen={isOpenModalAnalisar}><Analisar onClose={modalAnalisar} filial_id={filial_id} sessao_id={sessao_id}></Analisar></Modal>
        <Modal size="lg" isOpen={isOpenModalSessao}><Sessoes onClose={modalSessao} setSessao={setSessao_id} ></Sessoes></Modal>
        <Modal size="xl" isOpen={isOpenModalSmartPed}><SmartPed onClose={modalSmartPed} produtos={data} filial_id={filial_id}></SmartPed></Modal>
        <Modal
          key     = 'modrelat'
          size    = 'xl'
          height  = "700px"
          isOpen  = {isOpenModalImpressao}
        >
          <Iframe
            allowFullScreen
            id        = "myId"
            name      = "myId"
            className = "myClassname"
            width     = "100%"
            height    = "580px"
            display   = "initial"
            position  = "relative"
            url       = {pathPDF}
            >
          </Iframe>
          <Row>
            <Col className="text-center p-3">
              <Button
                type      = "button"
                className = "mb-0 mt-0"
                color     = "success"
                size      = "md"
                onClick   = {()=>{window.open(pathPDF)}}
              >Baixar
                </Button>
              <Button
                type      = "button"
                className = "mb-0 mt-0"
                color     = "default"
                size      = "md"
                onClick   = {()=>{setIsOpenModalImpressao(false)}}>Fechar</Button>
            </Col>
          </Row>
        </Modal>
        <Row>
          <Col md="12" className="p-0">
            <Card>
              <CardHeader>
                <Row>
                  <Col md='10'>
                    <CardTitle>ASSISTENTE DE PEDIDOS</CardTitle>
                  </Col>
                  <Col
                    md='2'
                  >
                    <h6 className="text-right mt-2" style={{ color: '#009900',cursor: 'pointer'}}onClick={modalSessao}><u>{`Sessão ${sessao_id}`}</u></h6>
                    {/* <p className="text-right" style={{ cursor: 'pointer', color: '#0059b3' }} onClick={modalSessao}><u>Alterar</u></p> */}
                  </Col>
                </Row>
              </CardHeader>

              <CardBody>
                {/* <div> */}
                <div className="border p-3">
                  <Row>
                    <Col md='7'>
                      <FormGroup>
                        <ReactSelect
                          name="lojas"
                          placeholder="Selecione a Loja"
                          options={listaLojas}
                          //defaultValue= {form.fornecedor}
                          onChange={onChangeLoja}
                        ></ReactSelect>
                      </FormGroup>
                    </Col>


                    <Col md="5" className="d-flex justify-content-around">
                      {/* <Row>
                          <Col md='12'

                          > */}
                      <ButtonGroup>
                        <UncontrolledDropdown>
                          <DropdownToggle caret className="mt-0 bg-success">
                            Ações
                          </DropdownToggle>
                          <DropdownMenu>
                            <DropdownItem
                              className="item-analisar-pedido"
                              onClick={showAnalisar}
                            >
                              Analisar
                            </DropdownItem>
                            <DropdownItem divider />
                            <DropdownItem
                              onClick={importarFaltas}
                            >

                              Importar Faltas
                            </DropdownItem>
                            <DropdownItem divider />
                            <DropdownItem
                              onClick={modalIncluirProd}
                            //disabled
                            >
                              Incluir Produto
                            </DropdownItem>
                            <DropdownItem divider />
                            <DropdownItem
                              onClick={apagarPedido}
                              className="item-excluir-pedido">
                              Apagar Pedido
                            </DropdownItem>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </ButtonGroup>

                      <ButtonGroup onClick={() => { setIsOpenFiltros(!isOpenFiltros) }}>
                        <UncontrolledDropdown>
                          <DropdownToggle caret className="mt-0 bg-info">
                            Filtros
                          </DropdownToggle>
                        </UncontrolledDropdown>
                      </ButtonGroup>

                      <ButtonGroup>
                        <UncontrolledDropdown>

                          <DropdownToggle caret className="mt-0 btn-ferramentas">
                            Ferramentas
                          </DropdownToggle>

                          <DropdownMenu>

                            <DropdownItem
                              className=""
                              onClick={modalRemessa}
                            >
                              Gerar Remessa
                            </DropdownItem>

                            <DropdownItem
                              className=""
                              onClick={()=>{setIsOpenModalSmartPed(!isOpenModalSmartPed)}}
                            >
                              SmartPed
                            </DropdownItem>

                            <DropdownItem
                              className=""
                              onClick={modalCotacao}
                            >
                              Cotação Digifarma
                            </DropdownItem>

                            <DropdownItem
                              className=""
                              onClick={gerarCotefacil}
                            >
                              Cotefácil
                            </DropdownItem>
                            {/* <DropdownItem divider /> */}

                            <DropdownItem
                              onClick={gerarSic}
                            //disabled
                            >
                              {"SIC(Febrafar)"}
                            </DropdownItem>

                            <DropdownItem
                              className=""
                              onClick={gerarCentralCotacoes}
                            >
                              Central de Cotações
                            </DropdownItem>
                            <DropdownItem
                              onClick={gerarCoteSimples}
                            >
                              Cote Simples
                            </DropdownItem>

                            <DropdownItem
                              onClick={gerarSmartGruppy}
                            >
                              Smart - Gruppy
                            </DropdownItem>

                            <DropdownItem divider />

                            <DropdownItem
                              className="bg-ferramentas"
                              onClick={modalConfig}
                            >
                              Configurar
                            </DropdownItem>



                            <DropdownItem
                              className="bg-ferramentas"
                              onClick={imprimirPedido}
                            >
                              Imprimir
                            </DropdownItem>

                            <DropdownItem
                              className="bg-ferramentas"
                              onClick={exportarExcel}
                            >
                              {'Exportar para Excel (Xlsx)'}
                            </DropdownItem>

                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </ButtonGroup>

                      {/* <span className="mx-2 border btn-filtro">
                              <i 
                                className="fa fa-filter icon-filtro" 
                                onClick={() => { setIsOpenFiltros(!isOpenFiltros) }}                                 
                              />
                            </span> */}
                      {/* </Col> */}

                      {/* <Col
                            md='6'
                          > */}


                      {/* <Button
                              onClick={() => { setIsOpenFiltros(!isOpenFiltros) }}
                              className="mt-0"
                            >Filtros</Button> */}
                      {/* </Col>
                        </Row> */}
                    </Col>
                  </Row>

                  {/* <Row className="py-2">

                      <Col className="text-right">
                        <i className={"icon-filtro " + (isOpenFiltros == true ? "fa fa-chevron-up" : "fa fa-chevron-down")}></i>
                      </Col>
                    </Row> */}
                  <Collapse isOpen={isOpenFiltros}>
                    <Row className=" mt-2 py-2"


                    >
                      {/* <Row className="border rounded"> */}
                      <Col md='4'>
                        <FormGroup>
                          <ReactSelect
                            name="categoria"
                            placeholder="Selecione a Categoria"
                            className="react-select selectXL mb-2"
                            classNamePrefix="react-select"
                            options={listaCategoria}
                            //defaultValue= {form.fornecedor}
                            onChange={(e) => { onChangeSelect(e, 'categoria_id') }}
                            isMulti
                          ></ReactSelect>
                        </FormGroup>
                      </Col>

                      <Col md='4'>
                        <FormGroup>
                          <ReactSelect
                            isMulti
                            id="subcategoria"
                            name="subcategoria"
                            className="react-select selectXL mb-2"
                            classNamePrefix="react-select"
                            placeholder="Selecione a Subcategoria"
                            options={listaSubcategoria}
                            onChange={(e) => { onChangeSelect(e, 'subcategoria_id') }}
                          // onClick={form.categoriaSelect ? form.categoria_id = form.categoriaSelect.id : ''}
                          // isDisabled={disabeldFiltros.selectCategoria}
                          />
                        </FormGroup>
                      </Col>

                      <Col md='4'>
                        <FormGroup>
                          <ReactSelect
                            isMulti
                            id="curvaAbc"
                            name="curvaAbc"
                            className="react-select selectXL mb-2"
                            classNamePrefix="react-select"
                            placeholder="Selecione a Curva"
                            options={listaAbc}
                            onChange={(e) => { onChangeSelect(e, 'curva_classe') }}
                          // onClick={form.categoriaSelect ? form.categoria_id = form.categoriaSelect.id : ''}
                          // isDisabled={disabeldFiltros.selectCategoria}
                          />
                        </FormGroup>
                      </Col>

                      <Col md='4'>
                        <FormGroup>
                          <ReactSelect
                            isMulti
                            id="fabricante"
                            name="fabricante"
                            className="react-select selectXL mb-2"
                            classNamePrefix="react-select"
                            placeholder="Selecione o Fabricante"
                            options={listaFabricante}
                            onChange={(e) => { onChangeSelect(e, 'fabricante_id') }}
                          // onClick={form.categoriaSelect ? form.categoria_id = form.categoriaSelect.id : ''}
                          // isDisabled={disabeldFiltros.selectCategoria}
                          />
                        </FormGroup>
                      </Col>

                      <Col md='4'>
                        <FormGroup>
                          <ReactSelect
                            isMulti
                            id="grupoCompra"
                            name="grupoCompra"
                            className="react-select selectXL mb-2"
                            classNamePrefix="react-select"
                            placeholder="Selecione o Grupo de Compras"
                            options={listaGrupoCompra}
                            onChange={(e) => { onChangeSelect(e, 'grupo_id') }}
                          // onClick={form.categoriaSelect ? form.categoria_id = form.categoriaSelect.id : ''}
                          // isDisabled={disabeldFiltros.selectCategoria}
                          />
                        </FormGroup>
                      </Col>

                      <Col md='4'>
                        <FormGroup>
                          <ReactSelect
                            isMulti
                            id="substancias"
                            name="substancias"
                            className="react-select selectXL mb-2"
                            classNamePrefix="react-select"
                            placeholder="Selecione a Substância"
                            options={listaSubstancia}
                            onChange={(e) => { onChangeSelect(e, 'substancia_id') }}
                          // onClick={form.categoriaSelect ? form.categoria_id = form.categoriaSelect.id : ''}
                          // isDisabled={disabeldFiltros.selectCategoria}
                          />
                        </FormGroup>
                      </Col>

                      <Col md='4'>
                        <FormGroup>
                          <ReactSelect
                            isMulti
                            id="fornecedores"
                            name="fornecedores"
                            className="react-select selectXL mb-2"
                            classNamePrefix="react-select"
                            placeholder="Selecione o Último Fornecedor"
                            options={listaFornecedores}
                            onChange={(e) => { onChangeSelect(e, 'last_fornecedor_id') }}
                          // onClick={form.categoriaSelect ? form.categoria_id = form.categoriaSelect.id : ''}
                          // isDisabled={disabeldFiltros.selectCategoria}
                          />
                        </FormGroup>
                      </Col>


                      {/* </Row> */}

                      {/* </Row> */}

                      {/* <Row className="mb-2 pb-2"> */}

                      <Col >
                        <FormGroup check inline className="my-3">
                          <Label check>
                            <Input
                              type="checkbox"
                              onChange={(e)=>{onChangeFiltro(e,'todos_produtos')}}
                              name='todos_produtos'
                            //defaultChecked={form.gerar_comissao_fp === 'S' ? true : false}
                            />
                            <span className="form-check-sign" />Todos os Produtos
                          </Label>
                        </FormGroup>{" "}
                      </Col>

                      <Col >
                        <FormGroup check inline className="my-3">
                          <Label check>
                            <Input
                              type="checkbox"
                              name='saldo_zero'
                              onClick={(e) => {onChangeFiltro(e,'saldo_zero')}}
                            //defaultChecked={form.gerar_comissao_fp === 'S' ? true : false}
                            />
                            <span className="form-check-sign" />Somente Saldo 0
                          </Label>
                        </FormGroup>{" "}
                      </Col>

                      {/* <Col >
                        <FormGroup check inline className="mb-0">
                          <Label check>
                            <Input
                              type="checkbox"
                              id="gerar_comissao_fp"
                            //onClick={onChange('gerar_comissao_fp')}
                            //defaultChecked={form.gerar_comissao_fp === 'S' ? true : false}
                            />
                            <span className="form-check-sign" />Por Laboratório
                          </Label>
                        </FormGroup>{" "}
                      </Col> */}


                      {/* <Col >
                        <FormGroup check inline className="mb-0">
                          <Label check>
                            <Input
                              type="checkbox"
                              id="gerar_comissao_fp"
                            //onClick={onChange('gerar_comissao_fp')}
                            //defaultChecked={form.gerar_comissao_fp === 'S' ? true : false}
                            />
                            <span className="form-check-sign" />Por Quat. Vendida
                          </Label>
                        </FormGroup>{" "}
                      </Col> */}

                      {/* <Col >
                        <FormGroup check inline className="mb-0">
                          <Label check>
                            <Input
                              type="checkbox"
                              id="gerar_comissao_fp"
                            //onClick={onChange('gerar_comissao_fp')}
                            //defaultChecked={form.gerar_comissao_fp === 'S' ? true : false}
                            />
                            <span className="form-check-sign" />Exibir Movimentação
                          </Label>
                        </FormGroup>{" "}
                      </Col> */}
                    </Row>


                  </Collapse>

                  <Row
                    hidden={tags.length > 0 ? false : true}
                  >
                    <TagsInput
                      value={tags}
                      disabled={true}
                      inputProps={{ placeholder: "" }}
                      // onChange={onChangeTag}
                      tagProps={{ className: 'react-tagsinput-tag info' }}
                    />
                  </Row>

                  <Row className='d-flex'>

                    <Col className='d-flex'
                    // md={filtro.todos_produtos.value == true ? '9' : '9'}
                    >
                      <div
                        className={exibirMovimentacao == true ? 'tongle-movimentacao-t active' : 'tongle-movimentacao-t'}
                      // className="tongle-movimentacao-t"
                      >
                        <TablePedidos
                          columns={colunas}
                          data={data}
                          onlyChecked={false}
                          changeCollapse={openDetalhesLojas}
                          isOpenDetalhesLojas={isOpenDetalhesLojas}
                          onBlurQtde={onBlurQtde}
                          filial_id={filial_id}
                          isLoadingRow={loadingRow}
                          movimentacao={exibirMovimentacao}
                          listarMovimentacao={listarMovimentacao}
                        ></TablePedidos>

                      </div>
                      {/* </Col> */}
                      {/* <Col hidden={filtro.todos_produtos.value} md='3'> */}
                      <span
                        className="d-flex justify-content-center align-items-center"

                      >
                        <i
                          hidden={data.length == 0}
                          className={" border rounded-circle p-2 bg-movimentacao " + (exibirMovimentacao == true ? 'fas fa-chevron-right' : ' fas fa-chevron-left')}
                          onClick={() => {
                            setExibirMovimentacao(!exibirMovimentacao);
                            // onChangeFiltro({target:{name:'Exibir Movimentação',value:'',checked:!filtro.exibirMovimentacao.value}},'exibirMovimentacao')
                          }}
                        ></i>
                      </span>
                      <div
                        className={exibirMovimentacao == true ? 'ml-3 tongle-movimentacao-m active' : 'tongle-movimentacao-m'}>

                        <Movimentação meses={listaMovimetacao} anos={listaUltimosAnos}></Movimentação>
                      </div>
                      {/* </span> */}
                      {/* </Col> */}

                      {/* <Col md='3'> */}
                      {/* <Movimentação></Movimentação>     */}
                    </Col>

                  </Row>

                  <Row className="mt-3">
                    <Col className="d-flex justify-content-between">
                      <div className="legenda"><i className="fas fa-circle mx-1 cor-manualmente"></i>Inserido Manualmente</div>
                  
                      <div className="legenda"><i className="fas fa-circle mx-1 cor-caderno"></i>Importado do Caderno de Faltas</div>
                    
                      <div className="legenda"><i className="fas fa-circle mx-1 cor-psicotropico"></i>Psicotrópico</div>
                  
                      <div className="legenda"><i className="fas fa-circle mx-1 cor-antimicrobiano"></i>Antimicrobiano</div>
                    </Col>
                  </Row>

                </div>
                {/* </div> */}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default AssistentePedidos;